
export default {
  getDefaultState: () => {
    return {
      retFlexColumns: [],
      subventionColumns: [],
      userRetFlexColumns: [] }
  }
}
